import React, { useEffect, useState } from 'react';

import moment from 'moment';
import capitalize from 'lodash/capitalize';
import axios from 'axios';
import Spinner from 'shared/lib/components/Spinner';
import ErrorPage from 'shared/lib/components/ErrorPage';
import { CancellationForm } from './cancellationComponents/CancellationForm';

import { Text, Title, Layout } from './components';

import './tinyCDL.css';
import { PolicyCard } from './cancellationComponents/PolicyCard';

const policyId = '1f5185de-4d05-4dde-9e8f-e464cde47a03';
const host = process.env.REACT_APP_API_V2;

// copy and paste bearer token
const token = '';
const headers = {
  'X-Space': 'sure',
  Authorization: `Bearer ${token}`,
};

const axiosOverride = axios.create();
axiosOverride.defaults.headers.common = headers;
axiosOverride.defaults.headers.common.accept = 'application/json';
axiosOverride.defaults.baseURL = process.env.REACT_APP_SURE_API_BASE_URL;

function Cancellations(props) {
  const [isLoading, setIsLoading] = useState(true);

  const isMobile = window.screen.width <= 1024;
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  // Still finalizing the cancel policy implementation
  // handleCancelPolicy = async () => {
  //   await fetch(`${host}/api/v2/policies/${policyId}/cancel`, {
  //     method: 'POST',
  //     headers,
  //   });
  // };

  const handleSubmit = values => {
    console.log(values);
  };

  const handleFetchData = async () => {
    axiosOverride(
      `${host}/api/v2/policies/${policyId}/?include=policy-holders&include=payment-method`,
      {
        method: 'GET',
        headers: headers,
      }
    )
      .then(response => {
        setData(response.data);
        setIsLoading(false);
      })

      .catch(error => {
        setError(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  if (isLoading)
    return (
      <Layout className="h-full flex items-center justify-center">
        <Spinner />
      </Layout>
    );

  if (error) {
    return <ErrorPage />;
  }
  if (data && !isLoading) {
    const {
      policy_number,
      rating_address: { city, region_code, postal, line1, line2 },
      policy_holders,

      starts_at,
      ends_at,
    } = data;

    const [primaryPolicyHolder] = policy_holders;

    // format names
    const fullName = `${capitalize(
      primaryPolicyHolder.person.first_name
    )} ${capitalize(primaryPolicyHolder.person.last_name)}`;

    // format address
    const line3 = `${city}, ${region_code} ${postal}`;

    const startDate = moment(starts_at).format('MMM D, YYYY');
    const endDate = moment(ends_at).format('MMM D, YYYY');

    const policyTerm = `${startDate} - ${endDate}`;
    return (
      <Layout
        grid="1-1"
        display={isMobile ? 'flex-column' : ''}
        className="w-100"
      >
        <Layout
          variant="form"
          display="flex-column"
          padding="large"
          className={isMobile ? 'p-50' : 'p-120'}
        >
          <Text variant="overline" color="brand-primary-base">
            Renters Policy Cancellation
          </Text>
          <Title variant="title-1" secondary>
            We're here to help.
          </Title>
          <Text color="foreground-secondary">
            We received your request for policy cancellation. Please review the
            details of your policy and confirm cancellation.
          </Text>
          <PolicyCard
            fullName={fullName}
            policyNumber={policy_number}
            address={{
              line1,
              line2,
              line3,
            }}
            policyTerm={policyTerm}
          />
        </Layout>
        <Layout
          className={`${isMobile ? 'p-50' : 'p-120'} h-screen`}
          background="background-primary"
          padding="large"
          display="flex-column"
          gap="large"
        >
          <Title secondary variant="title-3">
            Cancellation instructions
          </Title>
          <Text color="foreground-secondary">
            Sure values your business and regrets seeing you go. In order to
            proceed, please choose a reason for canceling your policy and
            specify an effective date.
          </Text>
          <Text color="foreground-secondary" variant="caption">
            Reason for cancellation
          </Text>
          <CancellationForm handleSubmit={handleSubmit} isMobile={isMobile} />
        </Layout>
      </Layout>
    );
  }
}
export default Cancellations;
